export const profieItems: Array<IProfileItems> = [
  {
    icon: 'icon-my-ads',
    title: 'آگهی‌های من',
    link: 'my-advertisment',
  },
  {
    icon: 'icon-bookmark-ads',
    title: 'آگهی‌های نشان شده',
    link: 'account/shown-ads',
  },
  {
    icon: 'icon-support',
    title: 'پشتیبانی',
    link: 'account/support',
  },
  {
    icon: 'icon-about',
    title: 'درباره حجره',
    link: 'account/about',
  },
  {
    icon: 'icon-Terms-and-Conditions',
    title: 'قوانین و مقررات',
    link: 'account/roles',
  },
];
